import axios from 'axios'
import common from '@/common/global'

let mainHost = process.env.mainHost
window.HOST = mainHost
// axios.defaults.baseURL = HOST
// axios.defaults.baseURL = ''
// axios.defaults.timeout = 1000 * 10
// axios.defaults.withCredentials = true
// axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_API_URL : '/'
// console.log('axios.defaults.baseURL:', axios.defaults.baseURL);
const isProduction = process.env.NODE_ENV === 'production'
axios.defaults.baseURL = isProduction ? '/' : ''
console.log('axios.defaults.baseURL:',axios.defaults.baseURL);
// console.log('axios.defaults.baseURL:',axios.defaults.baseURL);

axios.defaults.timeout = 1000 * 60
axios.defaults.withCredentials = true
//axios.defaults.headers['Content-Type'] = 'application/json;charset=uft8;'
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// request请求拦截器
axios.interceptors.request.use(function (config) {
    if (config.method == 'post') {
        // config.data = qs.stringify(config.data)// 防止post请求参数无法传到后台  在这里就用到了qs
    }
    return config
}, function (error) {
    return Promise.reject(error)
})

// respone响应拦截器
axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    return Promise.reject(error)
})

const apiMethods = {
    methods: {
        api({ baseURL, timeout, method, url, data }) {
            axios.create({
                baseURL: baseURL,
                timeout: timeout
            })
            return new Promise((resolve) => {
                axios({
                    method: method,
                    url: url,
                    data: data
                }).then(response => {
                    resolve(response.data)
                }).catch(error => {
                    // http.handleError(error)
                    console.log('error:', error);
                    
                })
            })
        },
        apiGet(url, data, config = {}) {
            let defaultConfig = {}
            if(data){
                defaultConfig.params = data
            }
            let mergedConfig = {...defaultConfig, ...config}
            return new Promise((resolve) => {
                axios.get(url, mergedConfig).then(response => {
                    resolve(response.data)
                }).catch(error => {
                    handleError(error)
                })
            })
        },
        apiPost(url, data) {
            return new Promise((resolve) => {
                axios.post(url, data, { headers: { 'Content-Type': 'application/json;charset=uft8;' } }).then(response => {
                    resolve(response.data)
                }).catch(error => {
                    handleError(error)
                })
            })
        },
        handleError(error) {
            var response = error.response
            var text = ''
            if (error.response) {
                var status = response.status
                var url = response.config.url
                if (url.indexOf('eventLog') >= 0) return

                switch (status) {
                    case 401:
                        text = '暂无权限，请稍后重试'
                        break
                    case 404:
                        text = '接口不存在，请稍后重试'
                        break
                    case 509: {
                        text = response.data.message
                        break
                    }
                    default:
                        text = '系统服务异常，请稍后重试'
                }
            } else if (error.request) {
                text = (('' + error.message).indexOf('timeout') >= 0) ? '请求超时，请检查网络'
                    : ('' + error.message.indexOf('Error') >= 0) ? '网络异常，请检查网络' : ''
            } else {
                text = (('' + error).indexOf('timeout') >= 0) ? '请求超时，请检查网络'
                    : ('' + error.indexOf('Error') >= 0) ? '网络异常，请检查网络' : ''
            }
            if (text == '') return
            common.toastMsg(text, 'warn')
        },
        reAjax(url, data) {
            return new Promise((resolve, reject) => {
                axios.post(url, data).then(response => {
                    resolve(response.data)
                }, response => {
                    reject(response)
                    common.toastMsg('请求超时，请检查网络', 'warn')
                })
            })
        }
    },
    // computed: {
    //     showLoading() {
    //         return store.state.globalLoading
    //     }
    // }
}

const handleError = (error) => {
    var response = error.response
    var text = ''
    if (error.response) {
        var status = response.status
        var url = response.config.url
        if (url.indexOf('eventLog') >= 0) return

        switch (status) {
            case 401:
                text = '暂无权限，请稍后重试'
                break
            case 404:
                text = '接口不存在，请稍后重试'
                break
            case 509: {
                text = response.data.message
                break
            }
            default:
                text = '系统服务异常，请稍后重试'
        }
    } else if (error.request) {
        text = (('' + error.message).indexOf('timeout') >= 0) ? '请求超时，请检查网络'
            : ('' + error.message.indexOf('Error') >= 0) ? '网络异常，请检查网络' : ''
    } else {
        text = (('' + error).indexOf('timeout') >= 0) ? '请求超时，请检查网络'
            : ('' + error.indexOf('Error') >= 0) ? '网络异常，请检查网络' : ''
    }
    if (text == '') return
    common.toastMsg(text, 'warn')
}
export default apiMethods
